import React from 'react';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
    return (
          <main 
            id="main-content"
            className="home-main min-h-screen bg-black text-white flex flex-col items-center justify-center relative"
            role="main"
            aria-label="Página inicial do Anuário Digital"
          >
          {/* Banner de fundo */}
          <div className="absolute inset-0 z-0" aria-hidden="true">
            <img
              src="https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=1500&q=80"
              alt=""
              className="w-full h-full object-cover opacity-20"
              loading="lazy"
            />
          </div>

          {/* Conteúdo principal */}
            <div className="z-10 px-6 py-24 text-center max-w-2xl">
              <h1 className="home-title text-5xl md:text-6xl font-bold text-gold mb-4 drop-shadow">
              Anuário Análise e Desenvolvimento de Sistemas - AMS <br />
              Turma 2025
            </h1>
              <p className="home-desc text-lg md:text-xl text-white/80 drop-shadow mb-8">
              Uma jornada de memórias, amizades e conquistas.
            </p>
            <Link
              to="/students"
              className="inline-block px-6 py-3 bg-gold text-black rounded-full text-lg font-semibold hover:bg-yellow-400 transition hover:no-underline focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black"
              aria-label="Ver a lista de alunos da turma"
            >
              Ver alunos
            </Link>
          </div>
        </main>
    );
};

export default HomePage;